import { resolveTeamDashboardSectionFullscreen } from "./teamDashboardSectionFullscreen.js";

const STORAGE_KEY = "kfu_team_dashboard_section_fullscreen";

function readMap() {
    if (typeof localStorage === "undefined") {
        return {};
    }

    try {
        const raw = localStorage.getItem(STORAGE_KEY);

        if (!raw) {
            return {};
        }

        const parsed = JSON.parse(raw);

        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
    } catch {
        return {};
    }
}

function writeMap(map) {
    if (typeof localStorage === "undefined") {
        return;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(map ?? {}));
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @returns {string|null}
 */
export function resolveTeamDashboardSectionFullscreenProfileId(userProfileId) {
    if (userProfileId != null && userProfileId !== "") {
        return String(userProfileId);
    }

    if (typeof localStorage === "undefined") {
        return null;
    }

    try {
        const fromStorage = localStorage.getItem("kaamfu_profile_id");

        return fromStorage ? String(fromStorage) : null;
    } catch {
        return null;
    }
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @returns {string|null|undefined} undefined when nothing stored for this profile
 */
export function readTeamDashboardSectionFullscreenFromStorage(userProfileId) {
    const profile_id = resolveTeamDashboardSectionFullscreenProfileId(
        userProfileId,
    );

    if (!profile_id) {
        return undefined;
    }

    const map = readMap();

    if (!Object.prototype.hasOwnProperty.call(map, profile_id)) {
        return undefined;
    }

    return resolveTeamDashboardSectionFullscreen(map[profile_id]);
}

/**
 * @param {string|null|undefined} serverValue
 * @param {string|null|undefined} storedValue
 * @returns {string|null}
 */
export function resolvePersistedTeamDashboardSectionFullscreen(
    serverValue,
    storedValue,
) {
    if (storedValue !== undefined) {
        return storedValue;
    }

    return resolveTeamDashboardSectionFullscreen(serverValue);
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @param {string|null|undefined} serverValue
 * @returns {string|null}
 */
export function hydrateTeamDashboardSectionFullscreen(
    userProfileId,
    serverValue,
) {
    return resolvePersistedTeamDashboardSectionFullscreen(
        serverValue,
        readTeamDashboardSectionFullscreenFromStorage(userProfileId),
    );
}

/**
 * @param {string|number|null|undefined} userProfileId
 * @param {string|null|undefined} section
 */
export function writeTeamDashboardSectionFullscreenToStorage(
    userProfileId,
    section,
) {
    const profile_id = resolveTeamDashboardSectionFullscreenProfileId(
        userProfileId,
    );

    if (!profile_id) {
        return;
    }

    const map = readMap();
    map[profile_id] = resolveTeamDashboardSectionFullscreen(section);
    writeMap(map);
}
